import { format as formatDate } from 'date-fns';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './resources/en';

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  debug: true,
  supportedLngs: ['en'],
  resources: {
    en: {
      translation: enTranslations,
    },
  },
  interpolation: {
    escapeValue: false,
    format: (value, format) => {
      if (value instanceof Date) {
        return formatDate(value, format);
      }
      //
      // if (format === 'currency') {
      //   return
      // }

      return value;
    },
  },
});

export default i18n;
